import { Store } from '../store/types';
import { DY_EVENTS } from '../actions';
import { dynamicYields, dyLoaded } from '../utils/dynamic-yields';
import { getDyPricesByIds } from '../api';
import type { DyCartSyncItem } from '../utils/dynamic-yields/types';

export const dynamic = (store: Store) => {
  store.on('@init', state => ({ ...state, dy: { isLoad: false } }));

  store.on(DY_EVENTS.init, state => {
    const result = { isLoad: false };
    dyLoaded()
      .then(() => {
        result.isLoad = true;
        dynamicYields.setDYSSVars();
        const { orchestratorHost, useCredentials, apiKey, requestID, model, userAgent } = store.get();
        const regionId = model?.properties.regionId;

        if (regionId && userAgent.length > 0 && dynamicYields.isNeedCartSync()) {
          const basket = window.layers.basket.getBasket();
          const products = basket.map(({ code }) => code);
          getDyPricesByIds(
            { products: products.join(','), regionId: String(regionId) },
            { orchestratorHost, useCredentials, apiKey, requestID }
          ).then(data => {
            const items = basket.reduce<DyCartSyncItem[]>((acc, current) => {
              const { code, quantity } = current;
              if (code in data) {
                acc.push({
                  productId: code,
                  quantity,
                  itemPrice: data[code],
                });
              }
              return acc;
            }, []);
            dynamicYields.syncCart(items);
          });
        }
      })
      .catch(() => {
        result.isLoad = false;
      });

    return {
      ...state,
      ...result,
    };
  });
};

export type DyStore = {
  dy: {
    isLoad: boolean;
  };
};
